import { useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import ServiceConnectionStep from "components/ServiceConnectionStep";

// -----------------------------------------------------------------------------

export default function AzureSPConnectSuccessPhase({
  shown,
}: Props): JSX.Element | null {
  const navigate = useNavigate();

  if (!shown) {
    return null;
  }

  //
  function backToSources() {
    navigate("/environment/sources");
  }

  //
  return (
    <ServiceConnectionStep disabled={false} sx={{ background: "#CFC" }}>
      <Box sx={{ mb: 1 }}>
        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
          You successly connected to Microsoft Azure!
        </Typography>
      </Box>
      <Button variant="contained" onClick={backToSources}>
        Back to sources
      </Button>
    </ServiceConnectionStep>
  );
}

// -----------------------------------------------------------------------------

interface Props {
  shown: boolean;
}
